export default __webpack_public_path__ + "static/media/view.c3c281c1.svg";